import { selectFeatureFlags } from 'core/userContext';
import { SMS_METRICS } from 'modules/billing/constants';
import { useQueryContext } from 'modules/billing/contexts/QueryContext';
import { useMetricInfo } from 'modules/billing/hooks/useMetricInfo';
import { createGlobalSmsRows } from 'modules/billing/utils';
import { useSelector } from 'react-redux';
import { AnalyticCard } from '../AnalyticCard';
import { AnalyticTable } from '../AnalyticTable';
import { GlobalSmsExportProjectUsageButton } from './GlobalSmsExportProjectUsageButton';
import { GLOBAL_SMS_CARD_IDS, GLOBAL_SMS_CARD_TEXT, GLOBAL_SMS_COLUMNS } from './constants';

const {
  cardTitle,
  description,
  smsSegmentsReceivedName,
  smsSegmentsSentDescription,
  smsSegmentsSentName,
} = GLOBAL_SMS_CARD_TEXT;

export const GlobalSmsUsageCard = () => {
  const { GlobalSmsFirstPartyUI } = useSelector(selectFeatureFlags);
  const {
    billingPeriodMetrics: { ByOrgBillingPartyRecipientCountry = [] },
    isLoading,
  } = useQueryContext();
  const globalSmsMetrics = ByOrgBillingPartyRecipientCountry[0] || [];
  const [smsSegmentsSentInfo, smsSegmentsReceivedInfo] = useMetricInfo([
    SMS_METRICS.smsSegmentsSent,
    SMS_METRICS.smsSegmentsReceived,
  ]);

  if (!GlobalSmsFirstPartyUI) {
    return null;
  }

  const cardMetrics = [
    {
      metricDescription: smsSegmentsSentDescription,
      metricName: smsSegmentsSentName,
      metricValue: smsSegmentsSentInfo.value,
      timePeriod: smsSegmentsSentInfo.dateRangeText,
    },
    {
      metricName: smsSegmentsReceivedName,
      metricValue: smsSegmentsReceivedInfo.value,
      timePeriod: smsSegmentsReceivedInfo.dateRangeText,
    },
  ];

  return (
    <AnalyticCard
      CardAction={<GlobalSmsExportProjectUsageButton />}
      description={description}
      data-test={GLOBAL_SMS_CARD_IDS.cardId}
      isLoading={isLoading}
      metrics={cardMetrics}
      title={cardTitle}
    >
      <AnalyticTable
        columns={GLOBAL_SMS_COLUMNS}
        gridLayout="1fr 160px"
        metrics={createGlobalSmsRows(globalSmsMetrics)}
      />
    </AnalyticCard>
  );
};
